import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, ThumbsUpIcon, ThumbsDownIcon, SmileIcon } from 'lucide-react';
type Post = {
  id: string;
  username: string;
  avatar: string;
  timestamp: string;
  content: string;
  sentiment: 'positive' | 'negative' | 'neutral';
  similarity: number;
};
type PostCardProps = {
  post: Post;
  isMatched: boolean;
};
const PostCard: React.FC<PostCardProps> = ({
  post,
  isMatched
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const sentimentIcon = () => {
    switch (post.sentiment) {
      case 'positive':
        return <ThumbsUpIcon className="w-4 h-4 text-green-400" data-id="element-56" />;
      case 'negative':
        return <ThumbsDownIcon className="w-4 h-4 text-red-400" data-id="element-57" />;
      default:
        return <SmileIcon className="w-4 h-4 text-blue-400" data-id="element-58" />;
    }
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0,
    boxShadow: isMatched ? '0 0 0 2px rgba(74, 222, 128, 0.5)' : 'none',
    scale: isMatched ? 1.02 : 1
  }} transition={{
    duration: 0.3
  }} className={`p-3 rounded-lg ${isMatched ? 'bg-gray-700 border border-green-400' : 'bg-gray-700'} cursor-pointer`} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} style={{
    transformOrigin: 'center',
    position: 'relative'
  }} data-id="element-59">
      <div className="flex justify-between items-start mb-2" data-id="element-60">
        <div className="flex items-center gap-2" data-id="element-61">
          <div className="w-8 h-8 rounded-full overflow-hidden" data-id="element-62">
            <img src={post.avatar} alt={post.username} className="w-full h-full object-cover" data-id="element-63" />
          </div>
          <div data-id="element-64">
            <div className="font-medium" data-id="element-65">@{post.username}</div>
          </div>
        </div>
        <div className="text-xs text-gray-400" data-id="element-66">{post.timestamp}</div>
      </div>
      <div className={`text-sm ${isHovered ? '' : 'line-clamp-3'}`} data-id="element-67">
        {post.content}
      </div>
      <div className="mt-2 flex justify-between items-center text-xs text-gray-400" data-id="element-68">
        <div className="flex items-center gap-1" data-id="element-69">{sentimentIcon()}</div>
        <div className="flex items-center gap-1" data-id="element-70">
          <span data-id="element-71">Similarity: {post.similarity.toFixed(2)}</span>
        </div>
      </div>
      {isMatched && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.5,
      repeat: 3,
      repeatType: 'reverse'
    }} className="absolute inset-0 rounded-lg border-2 border-green-400 pointer-events-none" data-id="element-72" />}
    </motion.div>;
};
export default PostCard;